<template>
    <transition name="fade" mode="out-in">
        <div class="pop form__customform_notify form__customform_notifyedit" v-show="isActive">
            <div class="form__customform_notify_overlay"></div>
            <div class="form__customform_notify_box" v-if="isActive">
                <header class="form__customform_notify_box_header">
                    <div class="form__customform_notify_box_header_title">
                        <template v-if="update">
                            {{ $t('forms.customForm.title.editField') }}
                        </template>
                        <template v-else>
                            {{ $t('forms.customForm.title.addField') }}
                        </template>
                    </div>
                    <div class="form__customform_notify_box_header_close">
                        <component-button
                            :name="'form-customform-notify-edit-close'"
                            :icon="true"
                            :icon-name="'x'"
                            :icon-raw="true"
                            @click="closeNotify"
                        ></component-button>
                    </div>
                </header>
                <div class="form__customform_notify_box_main">
                    <div class="form__customform_notify_box_main_content">
                        <form-text
                            :name="'field-label'"
                            :label="$t('forms.customForm.labels.fieldLabel')"
                            :required="true"
                            :v-validate="'required'"
                            v-model="form.label"
                        />
                        <form-radio-horizontal
                            :name="'field-type'"
                            :label="$t('forms.customForm.labels.fieldType')"
                            :required="true"
                            :v-validate="'required'"
                            :items="[
                                {
                                    name: this.$t('forms.customForm.labels.text'),
                                    value: 'text'
                                },
                                {
                                    name: this.$t('forms.customForm.labels.checkbox'),
                                    value: 'checkbox'
                                },
                                {
                                    name: this.$t('forms.customForm.labels.singleChoice'),
                                    value: 'single-choice'
                                },
                                {
                                    name: this.$t('forms.customForm.labels.multiChoice'),
                                    value: 'multi-choice'
                                }
                            ]"
                            :width="'full'"
                            v-model="form.type"
                        />
                        <transition name="fade" mode="out-in">
                            <template v-if="form.type === 'single-choice' || form.type === 'multi-choice'">
                                <div class="form__customform_notify_box_main_content_extra">
                                    <form-textarea
                                        :name="'field-options'"
                                        :label="$t('forms.customForm.labels.options')"
                                        :required="true"
                                        :size="'medium'"
                                        :v-validate="'required'"
                                        v-model="form.options"
                                    >{{ $t('forms.customForm.title.addOption') }}
                                    </form-textarea>
                                    <template v-if="form.type === 'single-choice' || form.type === 'multi-choice'">
                                    <form-checkbox
                                        :name="'field-errors-option'"
                                        :label="$t(`forms.customForm.labels.addOtherOption`)"
                                        v-model="form.additional.other"
                                    />
                                    </template>
                                </div>
                            </template>
                        </transition>
                        <form-textarea
                            :name="'field-help'"
                            :label="$t('forms.customForm.labels.helpText')"
                            :size="'small'"
                            v-model="form.helpText"
                        />
                        <form-checkbox
                            :name="'field-mandatory'"
                            :label="$t('forms.customForm.labels.mandatory')"
                            v-model="form.validation.mandatory"
                        />
                    </div>
                </div>
                <footer class="form__customform_notify_box_footer">
                    <div class="form__customform_notify_box_footer_actions">
                        <div class="columns is-variable">
                            <div class="column"></div>
                            <div class="column is-narrow">
                                <template v-if="update">
                                    <component-button
                                        :theme="'default'"
                                        :icon="true"
                                        :icon-name="'trash-2'"
                                        @click="remove"
                                        :name="'form-customform-notify-box-footer-actions-remove'"
                                    ></component-button>
                                </template>
                            </div>
                            <div class="column custom--line is-narrow">
                                <component-button
                                    :theme="'default'"
                                    :border="true"
                                    @click="closeNotify()"
                                    :name="'form-customform-notify-box-footer-actions-cancel'"
                                >{{ $t('forms.customForm.buttons.cancel') }}
                                </component-button>
                            </div>
                            <div class="column custom--line is-narrow">
                                <component-button
                                    :theme="'primary'"
                                    @click="submit"
                                    :name="'form-customform-notify-box-footer-actions-submit'"
                                >
                                    <template v-if="update">
                                        {{ $t('forms.customForm.buttons.updateField') }}
                                    </template>
                                    <template v-else>
                                        {{ $t('forms.customForm.buttons.AddFieldTo') }}
                                    </template>
                                </component-button>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    </transition>
</template>

<script>
import FormText from '@/components/default/forms/FormText'
import FormRadioHorizontal from '@/components/default/forms/FormRadioHorizontal'
import FormTextarea from '@/components/default/forms/FormTextarea'
import FormCheckbox from '@/components/default/forms/FormCheckbox'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  components: {
    FormCheckbox,
    FormTextarea,
    FormRadioHorizontal,
    FormText,
    ComponentButton
  },
  name: 'form-customform-notifyedit',
  data () {
    return {
      isActive: false,
      form: {
        id: '',
        label: '',
        type: '',
        validation: {
          mandatory: false
        },
        options: '',
        helpText: '',
        additional: {
          other: false
        },
        answers: ''
      },
      update: false,
      updateIndex: ''
    }
  },
  mounted () {
    let self = this
    let overlay = document.getElementsByClassName('form__customform_notify_overlay')
    for (let i = 0; i < overlay.length; i++) {
      overlay[i].addEventListener('click', function () {
        self.closeNotify()
      })
    }
  },
  methods: {
    closeNotify: function () {
      this.isActive = false
      this.form = {
        id: '',
        label: '',
        type: '',
        validation: {
          mandatory: false
        },
        options: '',
        helpText: '',
        additional: {
          other: false
        }
      }
      this.update = false
      this.updateIndex = ''
    },
    openNotify: function () {
      this.isActive = true
    },
    updateNotify: function (form, index) {
      this.form = JSON.parse(JSON.stringify(form))
      this.update = true
      this.updateIndex = index
    },
    //
    submit: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.update) {
            this.$emit('emit-edit', this.form, this.updateIndex)
          } else {
            this.$emit('emit-add', this.form)
          }
          this.closeNotify()
        }
      })
    },
    remove: function () {
      this.$emit('emit-remove', this.updateIndex)
      this.closeNotify()
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formcustomformnotify";
</style>
